import { Action } from '@ngrx/store';
import { LocationActionTypes, LocationActions } from '../actions';
import { LocationModel } from '@kanzi-apes/kanzi-models';

export interface State {
  location: LocationModel | null;
  loaded: boolean;
  loading: boolean;
  error: string | null;
}
export const initialState: State = {
  location: null,
  loaded: false,
  loading: false,
  error: null,
};

export function reducer(state: State = initialState, action: Action): State {
  const locationActions = action as LocationActions;
  switch (locationActions.type) {
    case LocationActionTypes.Create: {
      return {
        ...state,
        loaded: false,
        loading: true,
        error: null,
      };
    }
    case LocationActionTypes.CreateComplete: {
      return {
        ...state,
        location: locationActions.payload,
        loaded: true,
        loading: false,
        error: null,
      };
    }
    case LocationActionTypes.CreateError: {
      return {
        ...state,
        location: state.location,
        loaded: false,
        loading: false,
        error: locationActions.payload,
      };
    }
    case LocationActionTypes.LoadLocation: {
      return {
        ...state,
        loading: true,
      };
    }
    case LocationActionTypes.LoadLocationComplete: {
      return {
        ...state,
        loading: false,
        loaded: true,
        location: locationActions.payload,
      };
    }
    case LocationActionTypes.LoadLocationError: {
      return {
        ...state,
        error: locationActions.payload,
        loading: false,
      };
    }

    case LocationActionTypes.Delete: {
      return {
        ...state,
        location: locationActions.payload,
        loading: true,
        loaded: false,
      };
    }

    case LocationActionTypes.DeleteComplete: {
      return {
        ...state,
        location: null,
        loaded: true,
        loading: false,
      };
    }

    case LocationActionTypes.DeleteError: {
      return {
        ...state,
        error: locationActions.payload,
        loading: false,
        loaded: false,
      };
    }
    case LocationActionTypes.Edit: {
      return {
        ...state,
        loading: true,
      };
    }

    case LocationActionTypes.EditComplete: {
      return {
        ...state,
        location: locationActions.payload,
        loaded: true,
        loading: false,
        error: null,
      };
    }

    case LocationActionTypes.EditError: {
      return {
        ...state,
        loaded: false,
        loading: false,
        error: locationActions.payload,
      };
    }
    default: {
      return state;
    }
  }
}

export const getLocation = (state: State) => state.location;
export const getError = (state: State) => state.error;
export const getLoaded = (state: State) => state.loaded;
export const getLoading = (state: State) => state.loading;
